export default __webpack_public_path__ + "static/media/masl.24dcd1a5.png";